import React from "react";
import { productOperationsList } from "./constants/product.constants";
import { ProductList } from "./subPages/ProductList";
import { AddProduct } from "./subPages/NewProduct";
import { UpdateProduct } from "./subPages/UpdateProduct";
import { ProductTask } from "./subPages/ProductTask";
import { ProductPreview } from "./subPages/ProductPreview";
import { ProductTimeline } from "./subPages/ProductTimeline";
import { ProductAssignToPmc } from "./subPages/ProductAssignToPmc";
import { ProductPMCHandover } from "./subPages/ProductPMCHandover";
import { ProductExecutionTimeline } from "./subPages/ProductExecutionTimeline";
import { EditProductExecutionTimeline } from "./subPages/EditProductExecutionTimeline";
import { InputOutputForExecutionTimeline } from "./subPages/InputOutputForExecutionTimeline";
import { PmcHandoverChecklistPreview } from "./subPages/PmcHandoverChecklistPreview";
import { ExecutionTimelinePreview } from "./subPages/ExecutionTimelinePreview";

export const ProductPage = ({ currentOperationPage }) => {
  return (
    <>
      {currentOperationPage === productOperationsList.listProduct && (
        <ProductList />
      )}
      {currentOperationPage === productOperationsList.newProduct && (
        <AddProduct />
      )}
      {currentOperationPage === productOperationsList.updateProduct && (
        <UpdateProduct />
      )}
      {currentOperationPage === productOperationsList.productTask && (
        <ProductTask />
      )}
      {currentOperationPage === productOperationsList.previewProduct && (
        <ProductPreview />
      )}
      {currentOperationPage === productOperationsList.productTimeline && (
        <ProductTimeline />
      )}
      {currentOperationPage === productOperationsList.productPMCHandover && (
        <ProductPMCHandover />
      )}
      {currentOperationPage === productOperationsList.productAssignToPmc && (
        <ProductAssignToPmc />
      )}
      {currentOperationPage ===
        productOperationsList.productExecutionTimeline && (
        <ProductExecutionTimeline />
      )}
      {currentOperationPage ===
        productOperationsList.editProductExecutionTimeline && (
        <EditProductExecutionTimeline />
      )}
      {currentOperationPage ===
        productOperationsList.productInputOutputDetails && (
        <InputOutputForExecutionTimeline />
      )}
      {currentOperationPage ===
        productOperationsList.pmcHandoverChecklistPreview && (
        <PmcHandoverChecklistPreview />
      )}
      {currentOperationPage ===
        productOperationsList.executionTimelinePreview && (
        <ExecutionTimelinePreview />
      )}
    </>
  );
};
